import leapfrog from "./images/leapfrog.png";
import Image from 'react-bootstrap/Image';

function LeapfrogImage(){
    return <Image className='leapfrog-image' alt="Leapfrog Systems" src={leapfrog} height="40" />
        
   }
   export default LeapfrogImage